import { computed } from 'vue'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import { CMS } from '~/scopes/cms/routes-names'

export function useExpressReplacementUrl() {
  const locale = useI18nLocale()

  const expressReplacementUrl = computed(
    () => `/${locale}/${CMS.EXPRESS_REPLACEMENT}`,
  )

  return { expressReplacementUrl }
}
